<nav class="navbar navbar-expand-sm bg-dark navbar-dark"  style="color:#07207b">
   <div class="container">
      <a class="navbar-brand" href="#"><img src="assets/images/1.svg" 
         style="height:30px"></a>
      <ul class="nav navbar-nav navbar-right">
         <li class="nav-item">
            <a class="nav-link" id="a" href="#">Guides</a>
         </li>
         <li class="nav-item">
            <a class="nav-link" id="a" href="#">Blog</a>
         </li>
         <li class="nav-item">
            <a class="nav-link" id="a" href="#">About Us</a>
         </li>
         <li class="nav-item">
            <a class="nav-link"  id="a" href="#">***</a>
         </li>
         <li class="nav-item">
            <a class="nav-link" href="#"><button type="button" id="btn" 
               class="btn btn-default">Login</button></a>
         </li>
      </ul>
   </div>
</nav>
<section style="background-color:#0a1748;height: 30rem;margin-top: -3.5%;">
   <div class="container mt-5">
      <div class="row">
         <div class="col-md-12">
            <div class="card">
               <div class="card-header" style="background-color: #0a1748">
                  <ul class="nav nav-tabs justify-content-center" role="tablist">
                     <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#home" role="tab">
                        <i class="fa fa-bolt"></i> Customize
                        </a>
                     </li>
                     <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#profile" role="tab">
                        <i class="fa fa-bolt"></i> Deals
                        <button type="button" style="padding: 0px;width: 40px;font-size: 10px;"
                           class="btn btn-danger">New</button></a>
                     </li>
                     <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#messages" role="tab">
                        <i class="fa fa-bolt"></i> Packages
                        </a>
                     </li>
                  </ul>
               </div>
               <div class="card-body" style="padding:0px">
                  <div class="tab-content text-center">
                     <div class="tab-pane active" id="home" role="tabpanel">
                        <div>
                           <img src="assets/images/2.jpg" class="rounded" style="width: 100%;
                              height: 505px;"> 
                           <span style="position: relative;z-index: 999;opacity: 1;top: -25rem;
                              font-size: 32px;font-weight: bold;color: white;"
                              class="overlay-text">Craft your entire holiday, exactly
                           <br/>the way you want!</span>
                           <span style="position: relative;z-index: 999;opacity: 1;top: -25rem;
                              font-size: 32px;font-weight: bold;color: white;">
                              <form class="example">
                                 <a href="/customizesearchbar"><input type="text" id="inp" placeholder="Start Planning...">
                                 <button type="submit"><i class="fa fa-search"></i></button></a>
                              </form>
                           </span>
                        </div>
                     </div>
                     <div class="tab-pane" id="profile" role="tabpanel">
                        <div>
                           <img src="assets/images/3.jpg" class="rounded" style="width: 100%;
                              height: 505px;"> 
                           <span style="position: relative;z-index: 999;opacity: 1;top: -25rem;
                              font-size: 32px;font-weight: bold;color: white;"
                              class="overlay-text">Craft your entire holiday, exactly
                           <br/>the way you want!</span>
                           <span style="position: relative;z-index: 999;opacity: 1;top: -25rem;
                              font-size: 32px;font-weight: bold;color: white;">
                              <form class="example">
                                 <a href="/customizesearchbar"><input type="text" placeholder="Start Planning...">
                                 <button type="submit"><i class="fa fa-search"></i></button></a>
                              </form>
                           </span>
                        </div>
                     </div>
                     <div class="tab-pane" id="messages" role="tabpanel">
                        <div>
                           <img src="assets/images/4.jpg" class="rounded" style="width: 100%;
                              height: 505px;"> 
                           <span style="position: relative;z-index: 999;opacity: 1;top: -25rem;
                              font-size: 32px;font-weight: bold;color: white;"
                              class="overlay-text">Craft your entire holiday, exactly
                           <br/>the way you want!</span>
                           <span style="position: relative;z-index: 999;opacity: 1;top: -25rem;
                              font-size: 32px;font-weight: bold;color: white;">
                              <form class="example">
                                 <a href="/customizesearchbar"><input type="text" placeholder="Start Planning...">
                                 <button type="submit"><i class="fa fa-search"></i></button></a>
                              </form>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <section class="container">
      <div class="jumbotron" style="    background: rgb(229, 249, 243);
      margin-top: -10.3rem;
      position: relative;
      padding: 25px;
      height: 90px;">
         <div class="row">
            <div class="col-md-3">
               <div style="margin-top: -4px;">
                  <img src="assets/images/5.png" class="rounded-circle" style="width: 50px;">
                  <span class="overlay-text">&nbsp; Expert assistance</span>
               </div>
            </div>
            <div class="col-md-3">
               <div style="margin-top: -4px;">
                  <img src="assets/images/5.png" class="rounded-circle" style="width: 50px;"> 
                  <span class="overlay-text">&nbsp; Transparent pricing</span>
               </div>
            </div>
            <div class="col-md-3">
               <div style="margin-top: -4px;">
                  <img src="assets/images/5.png" class="rounded-circle" style="width: 50px;">
                  <span class="overlay-text">&nbsp; 24x7 Concierge</span> 
               </div>
            </div>
            <div class="col-md-3">
               <div style="margin-top: -4px;">
                  <img src="assets/images/5.png" class="rounded-circle" style="width: 50px;"> 
                  <span class="overlay-text">&nbsp; One-Stop Shop</span>
               </div>
            </div>
         </div>
      </div>
   </section>
</section>

<section id="tabs" style="margin-top: 300px;">
   <div class="container">
      <div class="row">
         <div class="col-md-2">
            <div class="view">
               <img src="assets/images/35.jpg" class="img-fluid" 
               style="width: 100%; border-radius: 5%;">
               <div class="mask pattern-8 flex-center">
                 <p id="h3a" class="white-text">Family<br/>
                  <span id="span2"> From ₹ 32,623
                  <span style="margin-left:40px;" ><i class="fas fa-arrow-right"></i></span>
                  </span>
                 </p>
               </div>
             </div>
             <div class="view" style="margin-top:20px;">
               <img src="assets/images/36.jpg" class="img-fluid" 
               style="width: 100%; border-radius: 5%;">
               <div class="mask pattern-8 flex-center">
                  <p id="h3a" class="white-text">Honey Moon<br/>
                  <span id="span2"> From ₹ 32,623
                  <span style="margin-left:40px;" ><i class="fas fa-arrow-right"></i></span>
                  </span></p>
               </div>
             </div>
         </div>
         <div class="col-md-2">
            <div class="view">
               <img src="assets/images/37.jpg" class="img-fluid" 
               style="width: 100%; border-radius: 5%;">
               <div class="mask pattern-8 flex-center">
                  <p id="h3a" class="white-text">Visa-on-arrival<br/>
                  <span id="span2"> From ₹ 32,623
                  <span style="margin-left:40px;" ><i class="fas fa-arrow-right"></i></span>
                  </span></p>
               </div>
             </div>
             <div class="view" style="margin-top:20px;">
               <img src="assets/images/37.jpg" class="img-fluid" 
               style="width: 100%; border-radius: 5%;">
               <div class="mask pattern-8 flex-center">
                  <p id="h3a" class="white-text">Adventure<br/>
                  <span id="span2"> From ₹ 32,623
                  <span style="margin-left:40px;" ><i class="fas fa-arrow-right"></i></span>
                  </span></p>
               </div>
             </div>
         </div>
         <div class="col-md-8">
            <div id="carousel-example-2" class="carousel slide carousel-fade" data-ride="carousel">
               <ol class="carousel-indicators">
                 <li data-target="#carousel-example-2" data-slide-to="0" class="active"></li>
                 <li data-target="#carousel-example-2" data-slide-to="1"></li>
                 <li data-target="#carousel-example-2" data-slide-to="2"></li>
               </ol>
               <div class="carousel-inner" role="listbox">
                 <div class="carousel-item active">
                   <div class="view">
                     <img class="d-block w-100" src="assets/images/32.jpg"
                       alt="First slide" style="width: 100%;">
                     <div class="mask rgba-black-light"></div>
                   </div>
                  <div class="sc-gtfDJT Eprwi">
                     <div class="sc-iSDuPN dGADzL">
                        <p class="wOfJv">
                        <span class="kCwZit">Prasanth Mor | 7 nights to Maldives</span><br/>
                        Our honeymoon to Mald....</p>
                        <button type="button" class="btn btn-default"
                        style="margin-top: 20px;background: rgb(0, 198, 132);color: #ffffff;">
                        See Itinerary</button>
                     </div>
                  </div>
                 </div>
                 <div class="carousel-item">
                   <div class="view">
                     <img class="d-block w-100" src="assets/images/33.jpg"
                       alt="First slide" style="width: 100%;">
                     <div class="mask rgba-black-strong"></div>
                   </div>
                   <div class="sc-gtfDJT Eprwi">
                     <div class="sc-iSDuPN dGADzL">
                        <p class="wOfJv">
                        <span class="kCwZit">Prasanth Mor | 7 nights to Maldives</span><br/>
                        Our honeymoon to Mald....</p>
                        <button type="button" class="btn btn-default"
                        style="margin-top: 20px;background: rgb(0, 198, 132);color: #ffffff;">
                        See Itinerary</button>
                     </div>
                  </div>
                 </div>
                 <div class="carousel-item">
                   <div class="view">
                     <img class="d-block w-100" src="assets/images/34.jpg"
                     alt="First slide" style="width: 100%;">
                     <div class="mask rgba-black-slight"></div>
                   </div>
                   <div class="sc-gtfDJT Eprwi">
                     <div class="sc-iSDuPN dGADzL">
                        <p class="wOfJv">
                        <span class="kCwZit">Prasanth Mor | 7 nights to Maldives</span><br/>
                        Our honeymoon to Mald....</p>
                        <button type="button" class="btn btn-default"
                        style="margin-top: 20px;background: rgb(0, 198, 132);color: #ffffff;">
                        See Itinerary</button>
                     </div>
                  </div>
                 </div>
               </div>
               <a class="carousel-control-prev" href="#carousel-example-2" role="button" data-slide="prev">
                 <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                 <span class="sr-only">Previous</span>
               </a>
               <a class="carousel-control-next" href="#carousel-example-2" role="button" data-slide="next">
                 <span class="carousel-control-next-icon" aria-hidden="true"></span>
                 <span class="sr-only">Next</span>
               </a>
             </div>
         </div>
      </div>
   </div>
</section>

<section id="tabs" style="margin-top: 100px;">
   <div class="container">
      <div class="row">
         <div class="col-md-6">
            <a href="#"><img src="assets/images/30.png" class="rounded" 
            style="width: 100%;"></a>
         </div>
         <div class="col-md-6">
            <a href="#"><img src="assets/images/31.png" class="rounded" 
               style="width: 100%;"></a>
         </div>
      </div>
   </div>
</section>

<section id="tabs" style="margin-top: 100px;">
	<div class="container">
		<h6 id="h6a">What the press say</h6>
		<div class="row">
			<div class="col-xs-12 ">
				<nav>
					<div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
						<a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">YOU STORY</a>
						<a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">NASSCOM</a>
						<a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">THE HINDU</a>
						<a class="nav-item nav-link" id="nav-about-tab" data-toggle="tab" href="#nav-about" role="tab" aria-controls="nav-about" aria-selected="false">TOI</a>
                  <a class="nav-item nav-link" id="nav-service-tab" data-toggle="tab" href="#nav-service" role="tab" aria-controls="nav-service" aria-selected="false">THE ECONOMIC TIMES</a>
               </div>
				</nav>
				<div class="tab-content py-3 px-3 px-sm-0" id="nav-tabContent">
					<div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                  <p id="par5">“PickYourTrail is also carving a niche for itself in this space and intends 
                  to become one-stop shop for personalised vacation”</p>
                  <p id="par6">YourStory | Jun 08, 2019 | <span id="span1">Read more</span></p>
					</div>
					<div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                  <p id="par5">“PickYourTrail is also carving a niche for itself in this space and intends 
                  to become one-stop shop for personalised vacation”</p>
                  <p id="par6">YourStory | Jun 08, 2019 | <span id="span1">Read more</span></p>
               </div>
					<div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
					   <p id="par5">“PickYourTrail is also carving a niche for itself in this space and intends 
                  to become one-stop shop for personalised vacation”</p>
                  <p id="par6">YourStory | Jun 08, 2019 | <span id="span1">Read more</span></p>
               </div>
					<div class="tab-pane fade" id="nav-about" role="tabpanel" aria-labelledby="nav-about-tab">
                  <p id="par5">“PickYourTrail is also carving a niche for itself in this space and intends 
                  to become one-stop shop for personalised vacation”</p>
                  <p id="par6">YourStory | Jun 08, 2019 | <span id="span1">Read more</span></p>
               </div>
               <div class="tab-pane fade" id="nav-service" role="tabpanel" aria-labelledby="nav-service-tab">
                  <p id="par5">“PickYourTrail is also carving a niche for itself in this space and intends 
                  to become one-stop shop for personalised vacation”</p>
                  <p id="par6">YourStory | Jun 08, 2019 | <span id="span1">Read more</span></p>
               </div>
				</div>
			</div>
		</div>
	</div>
</section>

<footer class="page-footer font-small unique-color-dark" id="footer">
   <div class="container text-center text-md-left" style="padding-top: 40px;">
      <div class="row mt-3">
         <div class="col-md-1"></div>
         <div class="col-md-9">
            <h4 id="h4">Our trusted travel partners around the world</h4>
            <div class="list-inline">
               <a href="#" id="1" class="list-inline">
                  <img src="assets/images/18.png" style="width: 120px;">
               </a>
               <a href="#" id="hon1" class="list-inline">
                  <img src="assets/images/19.png">
               </a>
               <a href="#" id="hon1" class="list-inline">
                  <img src="assets/images/20.png">
               </a>
               <a href="#" id="hon1" class="list-inline">
                  <img src="assets/images/21.png">
               </a>
               <a href="#" id="hon1" class="list-inline">
                  <img src="assets/images/22.png">
               </a>
               <a href="#" id="hon2" class="list-inline">
                  <img src="assets/images/23.png">
               </a>
               <a href="#" id="hon2" class="list-inline">
                  <img src="assets/images/24.png">
               </a>
               <a href="#" id="hon2" class="list-inline">
                  <img src="assets/images/25.png">
               </a>
               <a href="#" id="hon2" class="list-inline">
                  <img src="assets/images/26.png">
               </a>
               <a href="#" id="hon2" class="list-inline">
                  <img src="assets/images/27.png">
               </a>
               <a href="#" id="hon2" class="list-inline">
                  <img src="assets/images/28.png">
               </a>
            </div>
         </div>
         <div class="col-md-2"></div>
      </div>
   </div><hr id="hr"/>
   <div class="container text-center text-md-left" style="padding-top: 10px;">
      <div class="row mt-3">
         <div class="col-md-6">
            <p id="par3">Pickyourtrail is India's leading online travel company that delivers 
            tailor-made international holidays. Pickyourtrail aims to change the 
            customer experience so they can explore destinations at their own pace with
            completely customized tour packages. Our unique matching algorithm and price
            comparison engine ensures that travellers build their itinerary completely 
            suited to their tastes and at the best online prices. Pickyourtrail's intelligent
            platform helps save time and effort, without having to wait for a travel agent's
            quote, yet letting you have the fun of planning your own trip!</p>
            <p id="par4">Over the years, we have helped more than 10000+ travellers from across 14 
            countries explore their dream international holiday destinations. Pickyourtrail
            has the highest Five-star rating on Facebook by travellers, making us a top rated
            trip planner in India. We are an Amadeus Next incubated start-up and one of the
            top 6 finalists of the prestigious APAC Travel Innovation Summit award.</p>
         </div>
         <div class="col-md-6">
            <div>
               <img src="assets/images/16.gif" class="rounded" style="width: 100%;">
            </div>
         </div>
      </div>
   </div><hr id="hr"/>
   <div class="container text-center text-md-left" style="padding-top: 10px;">
      <div class="row mt-3">
         <div class="col-md-12">
            <h6 id="h6">Themed destinations</h6>
            <div class="list-inline">
               <a href="#" id="hon" class="list-inline">Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Family Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Beach Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Adventure Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Summer Holiday Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Visa on arrival</a>
            </div>
         </div>
      </div>
   </div><hr id="hr"/>
   <div class="container text-center text-md-left" style="padding-top: 10px;">
      <div class="row mt-3">
         <div class="col-md-12">
            <h6 id="h6">Holiday destinations</h6>
            <div class="list-inline">
               <a href="#" id="hon" class="list-inline">Australia Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Europe Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Dubai Tour Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;New Zealand  Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Singapore Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Thailand Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Bali Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Maldives Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Seychelles Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Malaysia Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;South Africa Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Cambodia Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp; Sri Lanka Tour Packages</a>
            </div>
         </div>
      </div>
   </div><hr id="hr"/>
   <div class="container text-center text-md-left" style="padding-top: 10px;">
      <div class="row mt-3">
         <div class="col-md-12">
            <h6 id="h6">Europe Special</h6>
            <div class="list-inline">
               <a href="#" id="hon" class="list-inline">France Tour Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Italy Tour Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Austria Tour Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Switzerland Tour Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Germany Tour Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Greece Tour Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Spain Tour Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;UK Tour Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Europe Tour Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Turkey Tour Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;London Tour Packages</a>
            </div>
         </div>
      </div>
   </div><hr id="hr"/>
   <div class="container text-center text-md-left" style="padding-top: 10px;">
      <div class="row mt-3">
         <div class="col-md-12">
            <h6 id="h6">Honeymoon Packages</h6>
            <div class="list-inline">
               <a href="#" id="hon" class="list-inline">Maldives Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Dubai Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Maldives Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Mauritius Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Switzerland Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Greece Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Turkey Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Sri Lanka Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Bali Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Italy Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Spain Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Seychelles Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Thailand Honeymoon Packages</a>
               <a href="#" id="hon" class="list-inline">. &nbsp;Singapore Honeymoon Packages</a>
            </div>
         </div>
      </div>
   </div><hr id="hr"/>
   <div class="container text-center text-md-left mt-5" style="padding-top: 40px;">
      <div class="row mt-3">
         <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
            <h6 class="pro">Pickyourtrail</h6>
            <p >
               <a id="par1" href="#!">About Us</a>
            </p>
            <p>
               <a id="par1" href="#!">Carrers</a>
            </p>
            <p>
               <a id="par1" href="#!">Blog</a>
            </p>
            <p>
               <a id="par1" href="#!">Testonimals</a>
            </p>
            <p>
               <a id="par1" href="#!">Guides</a>
            </p>
            <p>
               <a id="par1" href="#!">Visa</a>
            </p>
            <p>
               <a id="par1" href="#!">Press</a>
            </p>
         </div>
         <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
            <h6 class="pro">Policy</h6>
            <p >
               <a id="par1" href="#!">Frequently Asked Questions</a>
            </p>
            <p>
               <a id="par1" href="#!">Terms & Conditions</a>
            </p>
            <p>
               <a id="par1" href="#!">Privacy</a>
            </p>
            <p>
               <a id="par1" href="#!">Cancellations</a>
            </p>
            <p>
               <a id="par1" href="#!">Sitemap</a>
            </p>
            <p>
               <a id="par1" href="#!">Contact Us</a>
            </p>
         </div>
         <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
            <h6 class="pro">Talk to us</h6>
            <p>
               <a id="par1" href="#!"><i class="fas fa-envelope mr-3"></i>
                  planners@pickyourtrail.com</a>
            </p>
            <p>
               <a id="par1" href="#!"><i class="fas fa-phone mr-3"></i>
                  +919360991166</a>
            </p>
            <p>
               <a id="par1" href="#!"><i class="fas fa-comment mr-3"></i>
                  +917806805380</a>
            </p>
            <p>
               <a id="par1" href="#!"><form>
                  <div class="form-group">
                     <label style="color: #c1a698;">Sign up for travel ideas!</label>
                     <input type="text" id="inp1" class="form-control" placeholder="Your mail">
                  </div>
               </form></a>
            </p>
         </div>
         <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
            <h6 class="pro">Social</h6>
            <p>
               <a id="par1" href="#!"><i class="fab fa-facebook-f white-text mr-4">
               </i></a>
            </p>
            <p>
               <a id="par1" href="#!"><i class="fab fa-twitter white-text mr-4">
               </i></a>
            </p>
            <p>
               <a id="par1" href="#!"><i class="fab fa-linkedin-in white-text mr-4">
                </i></a>
            </p>
            <p>
               <a id="par1" href="#!"><i class="fab fa-instagram white-text">
               </i></a>
            </p>
            <p>
               <a id="par2" href="#!">Travel Troops Global Private Ltd.<br/>
                  © 2021 all rights reserved.
               </a>
            </p>
         </div>
      </div>
   </div>
</footer>

